import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { ICostType } from '../../../../models/cost-type.model';
import { Observable } from 'rxjs';
import { ICostTypeState } from '../../../../services/facades/master-data/cost-type-state.model';
import { CostTypeFacade } from '../../../../services/facades/master-data/cost-type.facade';

@Component({
    selector: 'app-cost-type-dialog',
    templateUrl: './cost-type-dialog.component.html',
    styleUrls: [ './cost-type-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostTypeDialogComponent implements OnInit, AfterViewInit {
    public costTypeState$: Observable<ICostTypeState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        private myMatDialogRef: MatDialogRef<CostTypeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostType,
        private myCostTypeFacade: CostTypeFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costTypeState$ = this.myCostTypeFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costType: ICostType) => {
            this.validateDialogFields(costType);
        });
    }

    public async save(): Promise<void> {
        const data: ICostType = this.formGroup.value as ICostType;
        data.isPrimary = isNullOrUndefined(data.isPrimary) ? false : data.isPrimary;
        if (isNullOrUndefined(this.data.id)) {
            const createdCostType: ICostType = await this.myCostTypeFacade.addKostenart(data);
            data.id = createdCostType.id;
        } else {
            data.id = this.data.id;
            await this.myCostTypeFacade.editKostenart(data);
        }
        // Check if assigned group has changed
        if (data.costTypeGroupId !== this.data.costTypeGroupId) {
            await this.myCostTypeFacade.assignCostTypeToGroup(data.costTypeGroupId, data.id);
        }
        this.myMatDialogRef.close(true);
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costType: ICostType): void {
        // Validations to disable saving/editing
        if (!costType.costTypeGroupId
            || !costType.name
            || ((isNullOrUndefined(costType.ledgerAccountNr) || costType.ledgerAccountNr.trim() === '') && costType.isPrimary)
            || (isNullOrUndefined(costType.distributionReferenceId) && costType.isPrimary)) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
